import { render, staticRenderFns } from "./CreateTicketDialog.vue?vue&type=template&id=089ff449"
import script from "./CreateTicketDialog.vue?vue&type=script&lang=js"
export * from "./CreateTicketDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports